module.exports = __webpack_public_path__ + "img/muzejW.0836f204.png";